/**
 * Combine root and child path.
 *
 * Examples:
 * `('shifts/abc123')` ➡️ `shift/abc123`
 * `('shifts/abc123', 'userID')` ➡️ `shift/abc123/userID`
 * `('users/xyz123', 'shifts/abc123')` ➡️ `users/xyz123/shifts/abc123`
 *
 * Pass generic type of `root` to enforce child path starting with actual keys.
 *
 * Example:
 * `getPath<Shift>('shifts/abc123', 'userID')` ➡️ `shift/abc123/userID`
 * `getPath<Shift>('shifts/abc123', 'youzerID')` ❌ TS Error
 *
 */
const getPath = (root, childPath) => `${root}${childPath ? `/${childPath}` : ''}`;

export { getPath };
